// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const DescendingSort: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5">
            <path
                fill="#393939"
                d="M4.28151037,11.5296876 C3.98854162,11.8226564 3.51276029,11.8226564 3.21979154,11.5296876 L0.219791545,8.52968764 C0.00416661633,8.31406236 -0.0591145621,7.99296904 0.0580729379,7.71171904 C0.175260438,7.43046904 0.447135581,7.24765682 0.751823081,7.24765682 L6.75182308,7.24765682 C7.05416669,7.24765682 7.32838572,7.43046904 7.44557322,7.71171904 C7.56276072,7.99296904 7.49713601,8.31406307 7.28385462,8.52968764 L4.28385462,11.5296876 L4.28151037,11.5296876 Z"
                transform="translate(-.002 -7)"
            />
        </svg>
    );
};

export default React.memo(DescendingSort);
